var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { find } from 'lodash';
import { DataService } from '@core/services/DataService';
import { Endpoints } from '@config/endpoints';
import { ProductService } from '@modules/Product/services/ProductService';
import { Subject } from 'rxjs/internal/Subject';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/DataService";
import * as i2 from "../../Product/services/ProductService";
var RoleService = /** @class */ (function () {
    function RoleService(dataService, productService) {
        this.dataService = dataService;
        this.productService = productService;
        this.rolesStatus = new Subject();
    }
    RoleService.prototype.getRoleById = function (productId) {
        return __awaiter(this, void 0, void 0, function () {
            var records, product, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.productService.getAll(1, '', productId)];
                    case 1:
                        records = (_a.sent()).records;
                        product = find(records, { id: productId });
                        if (!product) {
                            throw new Error('Product not found');
                        }
                        return [4 /*yield*/, this.dataService.request(Endpoints.GetRoles, {
                                links: product.links,
                            })];
                    case 2:
                        data = _a.sent();
                        this.rolesStatus.next(data.result);
                        return [2 /*return*/, data.result];
                }
            });
        });
    };
    RoleService.prototype.update = function (model, productId) {
        return __awaiter(this, void 0, void 0, function () {
            var records, product, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.productService.getAll(1, '', productId)];
                    case 1:
                        records = (_a.sent()).records;
                        product = find(records, { id: productId });
                        if (!product) {
                            throw new Error('Product not found');
                        }
                        return [4 /*yield*/, this.dataService.request(Endpoints.UpdateRoles, {
                                links: product.links,
                                data: model,
                            })];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    RoleService.ngInjectableDef = i0.defineInjectable({ factory: function RoleService_Factory() { return new RoleService(i0.inject(i1.DataService), i0.inject(i2.ProductService)); }, token: RoleService, providedIn: "root" });
    return RoleService;
}());
export { RoleService };
